import { NgModule } from "@angular/core";
import { TaxaJurosEquivalenteListagemComponent } from "./taxa-juros-equivalente/taxa-juros-equivalente-listagem.component";
import { TaxaJurosMaximaAgenteListagemComponent } from "./taxa-juros-maxima-agente/taxa-juros-maxima-agente-listagem.component";
import { TaxaJurosMediaAgenteListagemComponent } from "./taxa-juros-media-agente/taxa-juros-media-agente-listagem.component";
import { TaxaJurosMediaAgentePesquisaComponent } from "./taxa-juros-media-agente/taxa-juros-media-agente-pesquisa.component";
import { TaxasJurosRoutingModule } from "./taxas-juros-routing.module";
import { SharedModule } from "src/app/shared/shared.module";
import { NotasModule } from "../notas/notas.module";
import { DetalheModule } from "../contratacao/operacao/detalhe/detalhe.module";
import { BnComparacaoABModule } from "src/app/shared/modules/bn-comparacao.module";
import { JanelasApuracaoPesquisaComponent } from "./janelas-apuracao/janelas-apuracao-pesquisa.component";
import { JanelasApuracaoListagemComponent } from "./janelas-apuracao/janelas-apuracao-listagem.component";
import { JanelasApuracaoCadastroComponent } from "./janelas-apuracao/cadastro/janelas-apuracao-cadastro.component";







@NgModule({
    imports: [
        SharedModule,
        TaxasJurosRoutingModule
    ],
    exports: [],
    declarations: [
        TaxaJurosEquivalenteListagemComponent,
        TaxaJurosMaximaAgenteListagemComponent,
        TaxaJurosMediaAgentePesquisaComponent,
        TaxaJurosMediaAgenteListagemComponent,
        JanelasApuracaoPesquisaComponent,
        JanelasApuracaoListagemComponent,
        JanelasApuracaoCadastroComponent,
    ],
    providers: [],

  })
  export class TaxasJurosModule { }
  